import { render, staticRenderFns } from "./XvOrder.vue?vue&type=template&id=e0f9df44&scoped=true&"
import script from "./XvOrder.vue?vue&type=script&lang=ts&"
export * from "./XvOrder.vue?vue&type=script&lang=ts&"
import style0 from "./XvOrder.vue?vue&type=style&index=0&id=e0f9df44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f9df44",
  null
  
)

export default component.exports